<template>
  <div>
    <div class="order-detail-container" v-if="showDetail&&orderInfo_new">
      <div class="order-info">
        <div class="order-base-info">
          <div class="order-base-receive">
            <div>收件人信息</div>
            <ul class="info">
              <li>{{orderInfo_new.address.name}}</li>
              <li>{{orderInfo_new.address.phoneNumber}}</li>
              <li>{{orderInfo_new.address.province}}{{orderInfo_new.address.city}}{{orderInfo_new.address.district}}{{orderInfo_new.address.detailAddress}}</li>
            </ul>
          </div>
          <div class="order-base-delivery">
            <div>配送方式</div>
            <div
              class="info"
              v-if="orderInfo_new.status ==1 || orderInfo_new.status ==5 || orderInfo_new.status ==0 || orderInfo_new.status ==4"
            >-</div>
            <div
              class="info"
              v-else-if="orderInfo_new.status==2||orderInfo_new.status==22||orderInfo_new.status==3||orderInfo_new.status==6"
            >
              <div>快递</div>
              <div class="delivery-detail" @click="showDeliverInfo = true">物流详情</div>
            </div>
          </div>
        </div>
        <div class="order-create-info">
          <div class="item order-time">
            <div class="item-label">下单日期</div>
            <div class="item-value">{{orderInfo_new.createTime}}</div>
          </div>
          <div class="item order-no">
            <div class="item-label">订单号</div>
            <div class="item-value">{{orderInfo_new.orderNo}}</div>
          </div>
          <div class="item order-stauts">
            <div class="item-label">状态</div>

            <div v-if="orderInfo_new.status==0">
              <div class="del-tips" v-if="iscancle">
                <div>您确定吗？</div>
                <div>
                  <span class="span1" @click="canCelOrder(orderInfo_new.id)">是</span>
                  <span class="span2">或</span>
                  <span class="span1" @click="iscancle = false">否</span>
                </div>
              </div>
              <template v-else>
                <div class="item-value">
                  <div>待付款</div>
                  <div>（剩余{{min }} : {{sec}})</div>
                </div>
                <div class="go-pagy">
                  <div class="herf_tilte" @click="goPayorderdetail">立即支付</div>
                  <span class="herf_tilte" style="margin-left:1rem;">
                    <span class="herf_tilte" @click="cancle(orderInfo_new.id)">取消订单</span>
                  </span>
                </div>
              </template>
            </div>
            <div class="orderstatus" v-if="orderInfo_new.status=='1'">待发货</div>
            <div class="orderstatus" v-if="orderInfo_new.status=='2'">已发货</div>
            <div class="orderstatus" v-if="orderInfo_new.status=='22'">部分发货</div>
            <div class="orderstatus" v-if="orderInfo_new.status=='3'">已完成</div>
            <div class="orderstatus" v-if="orderInfo_new.status=='4'">已关闭</div>
            <div class="orderstatus" v-if="orderInfo_new.status=='5'">已退款</div>
            <div class="orderstatus" v-if="orderInfo_new.status=='6'">已签收</div>
          </div>
          <div class="item" v-if="refundList.length>0">
            <div class="item-label">退款信息</div>
            <div class="herf_tilte" @click="showRefoundInfo= true">查看</div>
          </div>
          <div class="item" v-if="exchangeList.length>0">
            <div class="item-label">换货信息</div>
            <div class="herf_tilte" @click="showRefoundExchangeInfo= true">查看</div>
          </div>
        </div>
        <div class="good-list">
          <div class="cart-item" v-for="(item, index) in orderInfo_new.skus" :key="index">
            <div class="cart-left">
              <div class="cart-img">
                <img :src="item.url" />
              </div>

              <div class="cart-info">
                <div class="cart-info-detail">
                  <div class="good-name">
                    <span>{{item.name}}</span>
                  </div>
                  <div class="good-size">
                    尺码.
                    <span
                      class="value"
                      v-for="(v, i) in item.specType"
                      :key="i"
                    >{{v}}{{i!=item.specType.length-1?'；':''}}</span>
                  </div>
                   <div class="good-color" v-if="remarkText">
                    姓名缩写.
                    <span class="value">{{remarkText}}</span>
                  </div>
                  <div class="good-color">
                    颜色.
                    <span class="value">{{item.colorText}}</span>
                  </div>
                  <div class="good-num">
                    数量.
                    <span class="value">{{item.count}}</span>
                  </div>
                </div>
                <div class="cart-price">
                  <template v-if="item.discountPrice!='0'&&item.discountPrice!=undefined">
                    <div
                      class="originprice"
                      style="margin-bottom:1.5rem"
                    >¥{{$utils.toThousands(item.price) }}</div>
                    <div class="currprice">¥{{$utils.toThousands(item.discountPrice)}}</div>
                  </template>

                  <template v-else>
                    <div class="currprice">¥{{$utils.toThousands(item.price)}}</div>
                  </template>
                  <div class="tips value" v-if="orderInfo_new.status==5">已退款</div>
                  <div class="tips value" v-if="item.status==102">换货中</div>
                  <div class="tips value" v-if="item.status==103">已换货</div>
                   <div class="tips value" v-if="item.status==104">换货撤销</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="pay-info">
        <div class="pay-info-item">
          <div class="pay-info-label">商品件数：</div>
          <div class="pay-info-value">{{orderInfo_new.count}}</div>
        </div>
        <div class="pay-info-item">
          <div class="pay-info-label">商品金额：</div>
          <div class="pay-info-value">¥{{$utils.toThousands(orderInfo_new.goodsTotalPrice)}}</div>
        </div>
        <div class="pay-info-item">
          <div class="pay-info-label">运费：</div>
          <div class="pay-info-value">¥{{orderInfo_new.orderFare?orderInfo_new.orderFare:'0.00'}}</div>
        </div>
        <div class="pay-info-item">
          <div class="pay-info-label">实付金额：</div>
          <div
            class="pay-info-value"
          >¥{{orderInfo_new.payAmount? $utils.toThousands(orderInfo_new.payAmount):0}}</div>
        </div>
      </div>
    </div>

    <delivery-info-pop
      v-if="orderInfo_new"
      :orderInfo="orderInfo_new"
      :showDeliverInfo="showDeliverInfo"
      v-on:close="closeInfo"
    ></delivery-info-pop>
    <refound-info-pop
      :refundList="refundList"
      :showRefoundInfo="showRefoundInfo"
      v-on:close="closeInfo"
    ></refound-info-pop>
    <refund-exchange-pop
    :exchangeList="exchangeList"
    :showRefoundExchangeInfo="showRefoundExchangeInfo"
    v-on:close="closeInfo"
    >
      
    </refund-exchange-pop>
    <!-- <pay-pop :showPay="showPay" v-on:close="closeInfo"></pay-pop> -->
  </div>
</template>

<script>
import DeliveryInfoPop from "./DeliveryInfoPop";
import RefoundInfoPop from "./RefoundInfoPop";
import RefundExchangePop from "./RefundExchangePop";
// import PayPop from "../common/PayPop";

export default {
  name: "PartLine",
  data() {
    return {
      showPay: false,
      showRefoundInfo: false,
      showDeliverInfo: false,
      showRefoundExchangeInfo:false,
      API: this.$store.state.API,
      iscancle: false,
      status: 1,
      refundList: [],
      exchangeList:[],
      orderInfo_new: null,
      remarkText:'',//刻字备注
      diffTime: 1 * 60 * 1000,
      min: "",
      sec: ""
    };
  },
  props: {
    showDetail: {
      type: Boolean,
      default: ""
    },
    orderInfo: {
      type: Object,
      default: null
    }
  },
  watch: {
    orderInfo: {
      immediate: true,
      handler(curVal, oldVal) {
       
        this.orderInfo_new = null;
        this.orderInfo_new = curVal;
   
        if(this.orderInfo_new.remarks){
          let remarks=this.orderInfo_new.remarks;
          let remarksList=remarks.split('&');
          let keziRemark=remarksList[1];
          let remarkText=keziRemark.startsWith('小')||keziRemark.startsWith('大')?keziRemark:''
          this.remarkText=remarkText?remarkText.split(',')[1]:'';
        }
        // console.log(keziRemark.sub)
        // console.log(keziRemark,'keziRemark')
        // console.log(remarksList,'remarksList')
        // console.log(remarks,'remarks')
        var create_time = this.orderInfo_new.createTime;
        var str = create_time.replace(/\-/g, "/");
        this.endTime = new Date(str).getTime() + 30 * 60 * 1000;
        this.countdown();
        // this.refundList = this.orderInfo_new.refundIds;
        // this.getRefundIds(this.orderInfo_new.skus);
        //处理换单的数据 找出哪些是退款，哪些是退货
        let skus=this.orderInfo_new.skus;
        skus.forEach((item,index)=>{
          if(item.refundId){
            if(item.status==102||item.status==103||item.status==104){
              this.exchangeList.push(item.refundId)
            }else{
               this.refundList.push(item.refundId)
            }
          }
        });



      },
      deep: true //true 深度监听
    }
  },
  components: {
    DeliveryInfoPop,
    RefoundInfoPop,
    RefundExchangePop
  },
  methods: {
    countdown() {
      const end = this.endTime;
      const now = new Date().getTime();
      const msec = end - now;
      let min = parseInt((msec / 1000 / 60) % 60);
      let sec = parseInt((msec / 1000) % 60);
      this.min = min > 9 ? min : "0" + min;
      this.sec = sec > 9 ? sec : "0" + sec;
      if (min >= 0 && sec >= 0) {
        if (min == 0 && sec == 0) {
          this.canCelOrder(this.orderInfo_new.id);
          return;
        }
        setTimeout(() => {
          this.countdown();
        }, 1000);
      }
    },
    getRefundIds(skus) {
      skus.forEach((v, i) => {
        if (v.refundId) {
          this.refundList.push(v.refundId);
        }
      });
    },
    goPayorderdetail() {
      console.log(this.orderInfo_new, "orderInfo_new");
      let e = {
        id: this.orderInfo_new.id,
        totalAmount: this.orderInfo_new.totalAmount
      };
      this.$emit("goPayorderdetail", e);
    },
    cancle(id, index) {
      this.iscancle = true;
    },

    async canCelOrder(id, index) {
      let url = this.API.order.cancelOrder;
      let OpenId = await this.$utils.CheckOpenIdExist(this);
      let params = {
        openId: OpenId || this.$store.state.userId,
        orderId: id,
        formId: "12"
      };

      this.$http
        .post(url, this.$qs.stringify(params))
        .then(res => {
          if (res.data.result) {
            this.iscancle = false;
            this.showDetail = true;
            this.orderInfo_new.status = 4;
            this.$emit("refreshOrder");
            this.$Message.success("取消订单成功");
          } else {
            this.$Message.error(res.data.message);
          }
        })
        .catch(err => []);
    },
    closeInfo() {
      this.showPay = false;
      this.showRefoundInfo = false;
      this.showDeliverInfo = false;
      this.showRefoundExchangeInfo=false;
    }
  }
};
</script>
<style lang="less" scoped>
.order-container {
  border: none;
}
.order-detail-container {
  .order-info {
    border: 0.1rem solid #eaeaea;
    .order-base-info {
      display: flex;
      padding: 2rem 2rem;
      border-bottom: 0.1rem solid #eaeaea;
      .order-base-receive {
        width: 40%;
        word-break: break-word;
        padding-right: 1rem;
      }
      .info {
        padding-top: 2rem;
        .delivery-detail {
          text-decoration: underline;
          cursor: pointer;
        }
      }
    }
    .order-create-info {
      padding: 2rem 2rem;
      display: flex;
      border-bottom: 0.1rem solid #eaeaea;
      margin-bottom: 2rem;
      .item {
        width: 25%;

        &.order-stauts {
          // width: 50%;
          .item-value {
            display: flex;
          }
        }
        .herf_tilte {
          cursor: pointer;
        }
        .go-pagy {
          display: flex;
          .del-tips {
            padding-left: 0.7rem;
          }
        }
      }
    }
  .good-list .cart-item .cart-left .cart-info{
    .good-name{
      justify-content:start
    }
    .originprice{
      margin-right:1.5rem
    }
    .originprice,.currprice{
      display:inline-block;
    }
   }

  }

  .pay-info {
    text-align: right;
    padding: 1.5rem 0 10rem;
    width: 30%;
    float: right;
    .pay-info-item {
      display: flex;
      -webkit-box-pack: end;
      -ms-flex-pack: end;
      justify-content: space-between;
    }
  }
}

@media screen and (max-width: 768px) {
  .good-list .cart-item .cart-left .cart-img {
    flex: 2;
  }
  .order-detail-container .order-info .order-base-info .order-base-receive {
    width: 50%;
  }
  .order-detail-container .order-info .order-create-info .item {
    &.order-no {
      width: 40%;
    }
    &.order-stauts {
      width: 35%;
    }
    &.order-time {
      padding-right: 0.5rem;
    }
  }

  .order-detail-container
    .order-info
    .order-create-info
    .item.order-stauts
    .item-value {
    // flex-direction: column;
  }
  .order-detail-container .pay-info {
    padding: 1.5rem 2rem 10rem;
    width: 60%;
  }
 
}
</style>


// WEBPACK FOOTER //
// src/components/common/OrderDetail.vue